import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./scss/google-fonts.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
